import type * as React from 'react'

export function CircleCheckIcon({
	size = 24,
	color = 'currentColor',
	strokeWidth = 2,
	className,
	...props
}: React.SVGProps<SVGSVGElement> & {
	size?: number
	color?: string
	strokeWidth?: number
}) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
			className={className}
			aria-label="Check icon"
			role="img"
			{...props}
		>
			<circle cx="12" cy="12" r="10" />
			<path d="m9 12l2 2l4-4" />
		</svg>
	)
}
